module.exports = "/img/cj-hol_logo.png?2fda234fbd68273f48cf30aa2e679ec3";